// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__CmvfZ"};